import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const GenericUncloseableModalLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "GenericUncloseableModal" */
      './GenericUncloseableModal.dynamic'
    ),
  loading: LoadingModal,
});
